var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('globbing-configs',{attrs:{"order-direction":1}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("平台全交易对通用【暴涨】抄底多梯度配置")])])
}]

export { render, staticRenderFns }